import React from "react";
import { Box } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useSelector } from "react-redux";
import UPDATE_USER_GUIDE from "src/graphql/mutation/user_guide/updateUserGuide";
import GET_USER_GUIDE from "src/graphql/query/user_guide/getUserGuide";
import { useTour } from "src/context/global/TourContext";
import NotConnectedBox from "./notConnectedBox";
import ConnectedBox from "./connectedBox";
import ErrorBox from "../../facebook/upperComponent/errorBox";
import InstagramInstructionsModal from "./instagramInstructionsModal";
import useStyle from "./Styles";

interface Props {
  pageExistingError: string | null;
  handleExistingPagesError: (value: string) => void;
  loggedInUserDetail: any;
  setloggedInUserDetail: (value: any) => void;
  setErrorBoxHeight: any;
  loading: boolean;
  modalRef: any;
  isCollapsed: boolean;
}

const ExternalPage: React.FC<Props> = ({
  loggedInUserDetail,
  setloggedInUserDetail,
  pageExistingError,
  handleExistingPagesError,
  setErrorBoxHeight,
  loading,
  modalRef,
  isCollapsed,
}) => {
  const { classes } = useStyle();
  const { me }: any = useSelector((state: any) => state.me);
  const { guideData, guideLoading } = useTour();
  const [updateUserGuide] = useMutation(UPDATE_USER_GUIDE);

  const hasAutoOpened = React.useRef(false);

  // Auto-open instructions modal on first visit
  React.useEffect(() => {
    if (
      !guideLoading &&
      guideData?.getUserGuide?.instagramGuideCompleted === false &&
      !hasAutoOpened.current &&
      modalRef.current
    ) {
      hasAutoOpened.current = true;
      modalRef.current.handleOpen();
    }
  }, [guideLoading, guideData, modalRef]);

  const handleLogout = () => {
    setloggedInUserDetail(null);
    try {
      if (window.FB) {
        window.FB.logout();
      }
    } catch (err) {
      console.warn("FB logout error", err);
    }
  };
  return (
    <>
      <Box className={classes.upperCompStyle}>
        {!loggedInUserDetail ? (
          <Box sx={{ position: "relative", width: "100%" }}>
            <NotConnectedBox
              handleOpenInstructions={() => modalRef.current?.handleOpen()}
              isCollapsed={isCollapsed}
            />
          </Box>
        ) : (
          <Box sx={{ position: "relative", width: "100%" }}>
            <ConnectedBox
              user={loggedInUserDetail}
              logout={handleLogout}
              loading={loading}
              isCollapsed={isCollapsed}
            />
          </Box>
        )}
        <InstagramInstructionsModal
          ref={modalRef}
          setModalState={async (open) => {
            if (
              !open &&
              me?.id &&
              guideData?.getUserGuide?.instagramGuideCompleted === false
            ) {
              try {
                await updateUserGuide({
                  variables: {
                    agentId: me.id,
                    instagramGuideCompleted: true,
                  },
                  refetchQueries: [
                    { query: GET_USER_GUIDE, variables: { agentId: me.id } },
                  ],
                });
              } catch (error) {
                console.error("Failed to update instagram guide status", error);
              }
            }
          }}
        />
      </Box>
      <ErrorBox
        error={pageExistingError || ""}
        handleClick={() => handleExistingPagesError("")}
        setErrorHeight={setErrorBoxHeight}
      />
    </>
  );
};

export default ExternalPage;
